import { render } from "./UsersList.vue?vue&type=template&id=34b0bb68&scoped=true"
import script from "./UsersList.vue?vue&type=script&lang=js"
export * from "./UsersList.vue?vue&type=script&lang=js"

import "./style.scss?vue&type=style&index=0&id=34b0bb68&scoped=true&lang=scss&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-34b0bb68"]])

export default __exports__